import { Expose } from "class-transformer";

export class UpdateCategoryDto {
  @Expose()
  id: string;

  @Expose()
  name: string;
}
